import { NgModule } from '@angular/core'

import { FlxIconModule, provideExtraIconSet } from '@flowx/angular-ui-toolkit'

import { ActivityNodeTypeIcons } from './bpmn-graph.constants'

@NgModule({
  imports: [FlxIconModule],
  providers: [
    provideExtraIconSet({
      ...ActivityNodeTypeIcons,
    }),
  ],
  exports: [FlxIconModule],
})
export class BpmnEditorIconsModule {}
